import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InputJobSetting from '../components/InputJobSetting';
import IAppState from '../../../IAppState';
import {
    IInputJobSettingsPropsData,
    IInputJobSettingsPropsFunctions,
} from '../props/IInputJobSettingsProps';
import ActMain from '../../../act-main';
import ActSummary from '../../SummaryPage/state/act-summary';
import { clientUrlPrefix } from '../../../settings';
import CALC from '../interfaces/Calculation';
import IMainState from '../../../IMainState';

function submitInput(dispatch: any, browserHistory: any) {
    dispatch(ActSummary.submitInput());

    browserHistory.push(clientUrlPrefix + '/job-setting2');
}

interface IOwnProps {
    ecNumber?: string;
    choice;
    customQuery?: boolean;
    history: any;
}

const mapStateToProps = (
    { mainState }: IAppState,
    ownProps: IOwnProps
): IInputJobSettingsPropsData => {
    return {
        jobTitle: mainState.jobTitle,
        email: mainState.email,
        pdbIdField: mainState.pdbIdField,
        uniprotIdField: mainState.uniprotIdField,
        pdbChainField: mainState.pdbChainField,
        selectedStructureInfo: mainState.selectedStructureInfo,

        lowRiskDesign: mainState.lowRiskDesign,
        highRiskDesign: mainState.highRiskDesign,
        ancestralDesign: mainState.ancestralDesign,

        forceFieldMutations: mainState.forceFieldMutations,
        bFactorAnalysis: mainState.bFactorAnalysis,
        consensusMutations: mainState.consensusMutations,
        calculation: mainState.calculation,
        indexes: mainState.indexes,
        userDefined: mainState.userDefined,
        ...mainState,
    };
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IOwnProps
): IInputJobSettingsPropsFunctions => ({
    changeLowRiskDesign: () => dispatch(ActMain.changeLowRiskDesign()),
    changeHighRiskDesign: () => dispatch(ActMain.changeHighRiskDesign()),
    changeAncestralDesign: () => dispatch(ActMain.changeAncestralDesign()),

    changeCalculation: (calculation: CALC) =>
        dispatch(ActMain.changeCalculation(calculation)),

    toggleForceFieldMutations: () =>
        dispatch(ActMain.toggleForceFieldMutations()),
    toggleBFactorAnalysis: () => dispatch(ActMain.toggleBFactorAnalysis()),
    toggleConsensusMutations: () => dispatch(ActMain.toggleConsensusMutations()),

    groupAutomatedSinglePoint: () => dispatch(ActMain.groupAutomatedSinglePoint()),
    groupAutomatedMultiplePoint: () => dispatch(ActMain.groupAutomatedMultiplePoint()),

    changejobTitle: (jobTitle: string) =>
        dispatch(ActMain.changejobTitle(jobTitle)),

    changeemail: (email: string) =>
        dispatch(ActMain.changeemail(email)),

    changePdbChainField: (pdbChainField: string) =>
        dispatch(ActMain.changePdbChainField(pdbChainField)),

    addRemoveMutation: (pos: number, res: string) =>
        dispatch(ActMain.addRemoveMutation(pos, res)),

    AddAllMutationsOnPosition: (pos: number,WTBase: string) =>
        dispatch(ActMain.AddAllMutationsOnPosition(pos, WTBase)),

    RemoveMutationsOnPosition: (pos: number) =>
        dispatch(ActMain.RemoveMutationsOnPosition(pos)),

    changePdbIdField: (pdbIdField: string) =>
        dispatch(ActMain.changePdbIdField(pdbIdField)),

    changeUniprotIdField: (uniprotIdField: string) =>
        dispatch(ActMain.changeUniprotIdField(uniprotIdField)),

    submitInput: () => submitInput(dispatch, ownProps.history),
    goBack: () => ownProps.history.goBack(),
});


const InputJobSettingContainer = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(InputJobSetting)
);

export default InputJobSettingContainer;
